<template>
  <!-- 数字农业·质量溯源·二级页面 -->
  <div>
    <div id="quality" ref="quality">
      <div class="echarts_border">
        <div class="btnBox">
          <div
            v-for="(item, index) in menuList"
            :key="index"
            :class="[isActive == index ? 'activeBtn' : 'btn']"
            @click="selectIndustry(index)"
          >
            <p class="btnTitle">{{ item.title }}</p>
          </div>
        </div>
        <!-- 制种 -->
        <left v-if="this.isActive == 0" />
        <!-- 奶产业 -->
        <right v-if="this.isActive == 1" />
        <p class="text-center">数据来源：{{ Data_txt }}、{{ Data_txtTwo }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// import * as echarts from "echarts";
import left from "../detail_quality/inputProduct.vue";
import right from "../detail_quality/traceSource.vue";
export default {
  components: {
    left,
    right,
  },
  props: {},
  data() {
    return {
      menuList: [{ title: "投入品" }, { title: "质量溯源" }],
      isActive: 0,
      Data_txt: "",
      Data_txtTwo: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 选择产业
    selectIndustry(index) {
      this.isActive = index;
    },
    // 数据来源
    Sources() {
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[4].quality;
      this.Data_txtTwo = dataSources.data[4].qualityTwo;
    },
  },
  created() {},
  mounted() {
    this.Sources();
  },
};
</script>
<style lang="less" scoped>
#quality {
  background: #15606e;
  border-top: 1px solid rgb(121, 226, 154);
}
.echarts_border {
  height: 39rem;
  overflow: auto;
  scrollbar-face-color: #0e4560;
}
.btnBox {
  margin: 34px 2rem;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;
}
.btn {
  width: 35%;
  height: 53px;
  // opacity: 0.3;
  background: rgba(138, 206, 254, 0.3);
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.activeBtn {
  width: 35%;
  height: 53px;
  // opacity: 0.47;
  background: rgba(0, 48, 82, 0.47);
  border: 1px solid #3ef89c;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.btnTitle {
  font-size: 26px;
  font-family: PingFang-SC-Medium;
  color: #ebfaff;
  line-height: 53px;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/detail_farming/quality.vue